import { useAuthStore } from "@modules/auth/store/useAuthStore";
import { useWorkspaceStore } from "@modules/workspace/store/useWorkspaceStore";
import { queryClient } from "@core/libs/react-query/react-queryClient";

/**
 * performLogout — clears all module stores and query cache.
 * Use this anywhere outside React (interceptors, event listeners).
 * Use useLogout() hook inside React components instead.
 */
export const performLogout = (): void => {
  useAuthStore.getState().logout();
  useWorkspaceStore.getState().clear();
  queryClient.clear();
};
